import useCreateMarkup from 'components/Dashboard/hooks/useCreateMarkup';
import time from 'utils/time';

const CrmInteractionNewContent = (props) => {
  const { currentNew, reportWidget } = props;
  const { title, interactionType, dateTime, addedByUserFullName, description, htmlBody, crmContactNames } =
    currentNew ?? {};

  const isEmailType = /email/i.test(interactionType);

  const { createMarkup } = useCreateMarkup();

  return (
    <>
      <div
        className={`section-title pb-2 interaction-content-title ${
          reportWidget ? 'content-title-in-widget' : 'content-title-with-summary'
        } content-border-title`}
      >
        <h3 className='main-title news-title bg-white content-item-title'>{title}</h3>
        <p className='heading-date mb-0'>
          {interactionType && (
            <>
              <span className='date'>{interactionType}</span>
              <span className='dot'></span>
            </>
          )}
          {addedByUserFullName && (
            <>
              <span className='date'>{addedByUserFullName}</span>
              <span className='dot'></span>
            </>
          )}
          {!isEmailType && crmContactNames?.length > 0 && (
            <>
              <span className='date'>
                {crmContactNames.length} stakeholder{crmContactNames.length > 1 ? 's' : ''}
              </span>
              <span className='dot'></span>
            </>
          )}
          {dateTime && <span className='date'>{time(dateTime).formatLongDate()}</span>}
        </p>
      </div>
      <div className='pb-3 pb-lg-4 px-3 px-lg-4 specific-content-container mt-2'>
        {(htmlBody || description) && (
          <div
            className='news-content-in parliamentary-content-in context'
            dangerouslySetInnerHTML={createMarkup(htmlBody || description)}
          />
        )}
      </div>
    </>
  );
};

export default CrmInteractionNewContent;
